import { useState } from "react";
import { useStore } from "@hooks/useZustandProvider";
import { useQuery } from "@apollo/client";
import { toast } from "react-toastify";
import { useRouter } from "next/router";
import { GET_WIDGET, GET_WIDGET_ADMIN } from "@api/queriesV2/cms";
import getBlockTemplate from "@components/cmsBlocks/getBlockTemplate";
import Block from "@components/cmsBlocks/Block";
import { mergeDataBlockWithDefaultData } from "@utils/cms";
import { useGetWidget, useGetWidgetAdmin } from "@api/hooks/queries/useGetSet";

const GetWidget = ({ type, id, isShow, updateField }) => {
  const { cms, addWidgetToWidgetsList } = useStore();
  const { list, isWidgetEditing, draft, lang: widgetLang } = cms.widget;
  const { lang: pageLang } = cms.page;
  const { isEditMode } = cms.uiOptions;
  const { locale } = useRouter();
  const [widgetData, setWidgetData] = useState(null);

  const blockTemplate = getBlockTemplate(type);

  const { Component } = blockTemplate;

  const { loading: adminLoading } = useGetWidgetAdmin({
    options: {
      skip: !isEditMode,
      variables: {
        id,
      },
    },
    onCompleted: (data) => {

      let widget = data.adminGetWidget;

      // TODO: create common function for handle widget data manipulation (check 4 places)
      const widgetLanguages = Object.keys(widget.languages).reduce(
        (langs, lang) => {

          const block = mergeDataBlockWithDefaultData(widget?.languages?.[lang] || {}, widget.type);

          return {
            ...langs,
            [lang]: {
              ...block,
              ...(!widget?.languages?.[lang] ? { isShow: false } : {})
            }
          };
        },
        {}
      );

      widget = {
        ...widget,
        languages: widgetLanguages,
      };

      addWidgetToWidgetsList(widget);
    },
  })

  const { loading: userLoading } = useGetWidget({
    options: {
      skip: isEditMode,
      variables: {
        id,
        language: locale,
      },
    },
    onCompleted: (data) => {
      const widget = data?.getWidget;

      setWidgetData({
        ...widget.languages,
        // name: widget.type
      });
    },
    onCompleteWithError: (data) => {
      const widget = data?.getWidget;

      if (!widget) {
        toast.error(`Widget ${id} for ${language} locale not found`);
      }
    },
  })

  // const { loading: adminLoading } = useQuery(GET_WIDGET_ADMIN, {
  //   context: { clientName: "v2" },
  //   skip: !isEditMode,
  //   fetchPolicy: "network-only",
  //   variables: {
  //     id,
  //   },
  //   onCompleted: (data) => {
  //     const error = data.adminGetWidget;

  //     if (error.ErrorCode) {
  //       return toast.error(`[${error.ErrorCode}]: ${error.ErrorReason}`);
  //     }

  //     let widget = data.adminGetWidget;


  //     // TODO: create common function for handle widget data manipulation (check 4 places)
  //     const widgetLanguages = Object.keys(widget.languages).reduce(
  //       (langs, lang) => {

  //         const block = mergeDataBlockWithDefaultData(widget?.languages?.[lang] || {}, widget.type);

  //         return {
  //           ...langs,
  //           [lang]: {
  //             ...block,
  //             ...(!widget?.languages?.[lang] ? { isShow: false } : {})
  //           }
  //         };
  //       },
  //       {}
  //     );

  //     widget = {
  //       ...widget,
  //       languages: widgetLanguages,
  //     };

  //     addWidgetToWidgetsList(widget);
  //   },
  //   onError: (error) => {
  //     toast.error(`[${error.name}]: ${error.message}`);
  //   },
  // });

  // const { loading: userLoading } = useQuery(GET_WIDGET, {
  //   context: { clientName: "v2" },
  //   skip: isEditMode,
  //   fetchPolicy: "network-only",
  //   variables: {
  //     id,
  //     language: locale,
  //   },
  //   onCompleted: (data) => {
  //     const widget = data?.getWidget;

  //     if (!widget) {
  //       toast.error(`Widget ${id} for ${language} locale not found`);
  //     }

  //     setWidgetData({
  //       ...widget.languages,
  //       // name: widget.type
  //     });
  //   },
  //   onError: (error) => {
  //     toast.error(`[${error.name}]: ${error.message}`);
  //   },
  // });

  const blockData = isEditMode
    ? isWidgetEditing
      ? draft.languages[widgetLang]
      : list?.[id]?.languages?.[pageLang]
    : widgetData;

  // if (userLoading) return null;

  const isLangShow = blockData?.isShow;

  if (!Component) return null;

  return isWidgetEditing || (isShow && isLangShow) ? (
    <Block
      index={0}
      widgetId={id}
      loading={isEditMode ? adminLoading : userLoading}
      block={blockData}
      blockTemplate={blockTemplate}
      updateField={updateField}
      {...{ "data-block-index": 0 }}
      {...{ "data-is-widget": true }}
    >
      <Component />
    </Block>
  ) : null;
};

export default GetWidget;
